import Rebut from "../../../model/multilleure/rebuts/Rebut";

const apiUrl = process.env.REACT_APP_API_URL;
export const PostRemesa = async ( rebuts: Rebut[], page : string, id_usu_log: string ) => {
    try {
        const response = await fetch(`${apiUrl}:8073/remeses2/${id_usu_log}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({rebuts : rebuts})
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            return "ERROR";
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
